import type { ONLINE_STATUS } from "@circle-react/components/constants";
import type { AvatarStatus } from "@circleco/compass/components/Avatar";

export type UserOnlineStatus =
  (typeof ONLINE_STATUS)[keyof typeof ONLINE_STATUS];

export const userStatusToAvatarStatus = (
  status?: UserOnlineStatus,
): AvatarStatus => {
  if (!status || status === "offline") {
    return "none";
  }

  return status;
};
